var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarfax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 378.51 70.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:#fff;}.cls-1{fill-rule:evenodd;}.cls-2{fill:#231f20;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M364.08,64a5.51,5.51,0,0,1-5.58,5.44H7.1A5.51,5.51,0,0,1,1.52,64V7A5.52,5.52,0,0,1,7.1,1.52H358.5A5.52,5.52,0,0,1,364.08,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M358.5,71H7.1A7,7,0,0,1,0,64V7A7,7,0,0,1,7.1,0H358.5a7,7,0,0,1,7.1,7V64A7,7,0,0,1,358.5,71ZM7.1,3A4,4,0,0,0,3,7V64A4,4,0,0,0,7.1,67.94H358.5A4,4,0,0,0,362.56,64V7A4,4,0,0,0,358.5,3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 303.72,
    y: 6.55,
    width: 55.17,
    height: 57.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 65.59,
    y: 5.87,
    width: 56.69,
    height: 59.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 124.74,
    y: 5.87,
    width: 56.69,
    height: 59.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 184.28,
    y: 5.87,
    width: 56.69,
    height: 59.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 243.82,
    y: 5.87,
    width: 56.69,
    height: 59.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.06,
    y: 5.87,
    width: 56.69,
    height: 59.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.71,56.28c-11.76,0-18-8.69-18-20.42,0-12.75,7.46-20.42,18.08-20.42,9.73,0,13.57,4.18,16.28,11.64L42.09,31c-1.41-3.69-2.77-6-6.38-6-4.59,0-6.57,4.59-6.57,10.88,0,6.06,1.92,10.88,6.68,10.88,3.44,0,4.92-1.87,7.06-5.61l9.27,4.94C49.5,51.25,45.09,56.28,35.71,56.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.37,39.53H90.81l.73-2.6c1.42-5,2-7.22,2.55-9.88.51,2.66,1.13,4.8,2.54,9.88ZM114,55.21,99.68,15.64H88.6L74.24,55.21H86l2.15-7H100l2.15,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M158.63,29c0,2.84-1.41,4.42-5,4.42H147.2V24.75h6.62C157.27,24.75,158.63,26.52,158.63,29Zm11.71,26.4-7.92-15.11c4.35-2,7.13-5.63,7.13-11.57,0-9.39-6.17-12.89-15.45-12.89H136.4V55.4h10.8V42h4.41l6.46,13.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M207.85,25.14v5.52h12.38v9.26H207.85V55.4H196.94V15.83h31.32v9.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M275,39.84h-6.56l.74-2.59c1.41-5,2-7.23,2.54-9.89.51,2.66,1.13,4.8,2.55,9.89Zm16.68,15.68L277.36,16H266.28L251.92,55.52h11.76l2.15-7H277.7l2.15,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M303,5.79V65h56.69V5.79ZM325.75,63.5l1-1.38A68.74,68.74,0,0,0,331,54.86c1.05,2.14,2.6,4.79,4.15,7.26L336,63.5Zm32.38,0h-8.45l-11.92-17L351.43,27.3H337.82l-2.41,3.83a80.72,80.72,0,0,0-4.21,7.2,67.07,67.07,0,0,0-4.15-7.2l-2.41-3.83H310.72l13.67,19.46L312.31,63.5h-7.82V7.32h53.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M377,1.73A5,5,0,0,0,373.27.16a5,5,0,0,0-3.74,1.57A5.29,5.29,0,0,0,368,5.56a5.16,5.16,0,0,0,1.55,3.78,5.08,5.08,0,0,0,3.73,1.56A5,5,0,0,0,377,9.33a5.22,5.22,0,0,0,1.53-3.79A5.25,5.25,0,0,0,377,1.73Zm-.76,7-1.89-2.53a2.25,2.25,0,0,0,1.27-.53,1.83,1.83,0,0,0,.65-1.46,1.81,1.81,0,0,0-.57-1.37A2.33,2.33,0,0,0,374,2.26h-3.15V8.69H372V6.18h.93l1.89,2.51h1.39a4,4,0,0,1-3,1.28,4.08,4.08,0,0,1-3-1.3A4.28,4.28,0,0,1,369,5.56a4.37,4.37,0,0,1,1.26-3.13,4.1,4.1,0,0,1,3.06-1.31,3.93,3.93,0,0,1,2.93,1.31,4.39,4.39,0,0,1,1.26,3.11,4.36,4.36,0,0,1-1.26,3.12Zm-1.13-4.53c0,.67-.42,1-1.28,1H372V3.31h1.73C374.65,3.31,375.09,3.59,375.09,4.16Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarfax);
export default __webpack_public_path__ + "static/media/carfax.0a8519cc93d2bcf53433a6ba21ef00ef.svg";
export { ForwardRef as ReactComponent };